import { styled } from '@stitches/configed';
import AddIcon from '@you-go-vn/components/src/Common/Icons/AddIcon';
import { Dropdown, DropDownProps } from 'antd';

const ActionStyled = styled('div', {
  cursor: 'pointer',
  color: '$brand',
  fontWeight: 500,
  alignItems: 'center',
  display: 'none',
  '@xs': {
    display: 'flex',
  },
  div: {
    height: 50,
    backgroundColor: '#F9AA1A',
    color: '$text1',
    padding: '12px 16px',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  span: {
    display: 'flex',
    fontSize: 16,
    transition: 'all 0.3s',
  },
  variants: {
    display: {
      false: {
        display: 'none',
      },
    },

    background: {
      white: {
        div: {
          backgroundColor: '#fff',
        },
      },
    },
  },
});

type Props = {
  menu?: DropDownProps['overlay'];
  text?: string;
  onClick?: () => void;
  background?: 'white';
  icon?: React.ReactNode;
  className?: string;
};
export const ActionButton = ({ menu, text, onClick, background, icon, className }: Props) => {
  return (
    <>
      {menu ? (
        <Dropdown className={className || 'active-icon-animate'} overlay={menu} trigger={['click']}>
          <ActionStyled background={background}>
            <div>
              {text || 'Tác vụ'}
              <span className="icon">
                {icon || <AddIcon />}
              </span>
            </div>
          </ActionStyled>
        </Dropdown>
      ) : (
        <ActionStyled onClick={onClick} background={background}>
          <div>
            {text}
            <span className="icon">
              {icon || <AddIcon />}
            </span>
          </div>
        </ActionStyled>
      )}
    </>
  );
};

const DropdownMobile = styled(Dropdown, {
  color: '$brand',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  '@xs': {
    display: 'none',
  },
});

const ActionMobileStyled = styled('div', {
  color: '$brand',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  '@xs': {
    display: 'none',
  },
});
export const ActionButtonMobile = ({ menu, text, onClick }: Props) => {
  return (
    <>
      {menu ? (
        <DropdownMobile overlay={menu} trigger={['click']}>
          <div>
            <AddIcon />
            <span>Tác vụ</span>
          </div>
        </DropdownMobile>
      ) : (
        <ActionMobileStyled onClick={onClick}>
          <AddIcon />
          <span>{text}</span>
        </ActionMobileStyled>
      )}
    </>
  );
};
